/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { Select, SelectProps } from '@mantine/core'
import { parseBoolean } from '@jalik/form-parser'
import FormField from '../../../../client/js/components/form/fields/FormField'

export type EquippedFieldProps = Omit<SelectProps, 'data'> & {
  nullable?: boolean;
}

function EquippedField (props: EquippedFieldProps) {
  const {
    name = 'equipped',
    nullable,
    ...others
  } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'equipment',
        defaultMessage: 'Équipement'
      })}
      {...others}
      name={name}
      parser={parseBoolean}
      render={Select}
      data={[
        {
          label: intl.formatMessage({
            id: 'undefined',
            defaultMessage: 'Non défini'
          }),
          value: ''
        },
        {
          label: intl.formatMessage({
            id: 'equipped',
            defaultMessage: 'Équipé'
          }),
          value: 'true'
        },
        {
          label: intl.formatMessage({
            id: 'not_equipped',
            defaultMessage: 'Non équipé'
          }),
          value: 'false'
        }
      ].filter((el) => nullable || el.value !== '')}
    />
  )
}

export default EquippedField
